import React, { useEffect, useState } from "react";
import Chart from "chart.js/auto";
import edMantra from "../../services/edMantra";
import Track from "../LeadManagementPages/Track";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { json } from "react-router-dom";
import { MdEdit, MdOutlineDelete } from "react-icons/md";
import getAttachmentUrl from "../../utils/getAttachmentUrl";
const Dashboard = () => {
  const { data } = useSelector((state) => state?.currentSession?.userInfo);
  const [notices, setNotices] = useState([]);
  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const openModal = (attachmentName) => {
    setSelectedAttachment(attachmentName);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedAttachment(null);
  };

  const handleDelete = async (noticeId) => {
    if (!window.confirm("Are you sure you want to delete this notice?")) return;

    try {
      const res = await edMantra.deleteNotice(noticeId);
      if (res.data.errorCode === 0) {
        toast.success("Notice deleted successfully");
        getNotices(); // refresh list
      } else {
        toast.error(res.data.message || "Failed to delete notice");
      }
    } catch (error) {
      console.error("Error deleting notice:", error);
      toast.error("Something went wrong");
    }
  };

  const getNotices = async () => {
    try {
      const res = await edMantra.getNotices();
      if (res.data.errorCode === 0) {
        setNotices(res.data.data);
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error("Failed to fetch notices");
      console.error(err);
    }
  };

  useEffect(() => {
    getNotices();
  }, []);

  const viewByPermission = () => {
    return (
      <>
        <div className="container mt-5">
          <h2 className="display-6">
            Latest <small className="text-muted">News & Notice</small>
          </h2>

          {notices.length === 0 ? (
            <p>No notices found.</p>
          ) : (
            <div className="row">
              {notices.map((notice) => (
                <div key={notice.noticeId} className="col-md-12 mb-4">
                  <div className="card bg-dark" style={{ width: "100%" }}>
                    {/* Optional image */}
                    {/* <img
                    src={notice.imageUrl || ""}
                    className="card-img-top"
                    alt={notice.title}
                  /> */}
                    <div className="card-body">
                      <h5 className="card-title text-light">{notice.title}</h5>
                      <p className="card-text text-light">
                        {notice.description}
                      </p>
                      <p className="card-text text-light">
                        <small style={{ color: "#f8f9fa" }}>
                          Date: {notice.noticeDate}
                        </small>
                      </p>
                      {notice.attachmentName && (
                        <button
                          className="btn btn-primary"
                          onClick={() => openModal(notice.attachmentName)}
                        >
                          View Attachment
                        </button>
                      )}

                      {data?.role?.roleName === "SuperAdmin" && (
                        <MdOutlineDelete
                          size={25}
                          color="red"
                          style={{ cursor: "pointer", float: "right" }}
                          onClick={() => handleDelete(notice.noticeId)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Modal */}
        {showModal && (
          <div
            className="modal show fade d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Attachment Preview</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body text-center">
                  <iframe
                    src={getAttachmentUrl(selectedAttachment)} // ✅ always resolve properly
                    title="Attachment"
                    style={{ width: "100%", height: "500px", border: "none" }}
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  return <>{viewByPermission()}</>;
};

export default Dashboard;
